"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
function checkpointZeroState(content, user) {
    const timestamp = new Date().toISOString();
    const { userId, companyId } = user;
    const checkpointState = {
        contentType: entity_1.StateContentType.CHECKPOINT,
        userId,
        contentId: content._id,
        rootContentId_contentId: `${content._id}_${content._id}`,
        companyId,
        modelType: 'activity',
        progressMeasure: 0,
        scaledProgressMeasure: 0,
        completionStatus: entity_1.CompletionStatus.NOT_ATTEMPTED,
        successStatus: entity_1.CheckpointSuccessStatus.NA,
        forceComplete: false,
        timeSpent: 0,
        submissionCount: 0,
        reAttemptCount: 0,
        submissions: [],
        lastUpdatedTimeSpent: null,
        statusLastUpdatedAt: null,
        lastSubmittedOn: null,
        createdAt: timestamp,
        updatedAt: timestamp,
        startedOn: null,
        lastAccessedOn: null,
        completedOn: null,
        deleted: false
    };
    return checkpointState;
}
exports.default = checkpointZeroState;
//# sourceMappingURL=checkpointZeroState.js.map